import { Component,Input, ViewEncapsulation, Output, EventEmitter } from '@angular/core';
import { UntypedFormGroup, UntypedFormBuilder, Validators} from '@angular/forms';
import { VesselsService } from '../../../../../services/vessels.service';
import { DatePipe } from '@angular/common';
import { StorageService } from '../../../../../services/storage.service';
import { ToasterService } from 'src/app/services/toaster.service';

@Component({
  selector: 'app-mark-as-status',
  templateUrl: './mark-as-status.component.html',
  styleUrls: ['./mark-as-status.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class MarkAsStatusComponent {
  @Input() iStatusForm :any;
  @Input() shipDetail :any;
  @Output() closeMarkAsStatus = new EventEmitter();
  

  public statusForm: UntypedFormGroup;
  public submit:boolean = false;
  public setting = { showCloseIcon: false, backdropClick: false };
  minDate:any = '';
  constructor(
    private fb: UntypedFormBuilder,
    private _vesselService: VesselsService,
    public datepipe: DatePipe,
    private toasterService: ToasterService,
    private _storageService: StorageService
  ) {
  }
 
 createStatusForm() {
    this.statusForm = this.fb.group({
      vslNumber: [this.shipDetail?.vslNumber,Validators.required],
      action: [(this.shipDetail?.iActive) ? 'inactive' : 'active',Validators.required],
      effectiveDate: ['',Validators.required],
      resion: ['',Validators.required],
    });
  }
  get s() { return this.statusForm.controls; }

  ngOnInit() {
    let date =  new Date();
    this.minDate = new Date((date.getFullYear()) + '-' + (date.getMonth()+1) + '-' + (date.getDate()));
    this.createStatusForm();
  }

  public closePopup(){
    this.closeMarkAsStatus.emit(false);
    document.body.style.overflow = "auto";
  }
  selectedDate(event:any){
    let selectDate = new Date(event);
    let effectiveDate = selectDate.getDate().toString().padStart(2, "0") + '.' + (selectDate.getMonth() + 1).toString().padStart(2, "0") + '.' + selectDate.getFullYear();
    this.statusForm.patchValue({ effectiveDate: effectiveDate});
  }

  public saveStatus(){
    this.submit = true;
    if (this.statusForm.invalid) {
       return;
    }

    let effectiveForm = this.statusForm.value.effectiveDate.split(".");
    let date = new Date(effectiveForm[2] + '-' + effectiveForm[1] + '-' + effectiveForm[0]);
    let effectiveDate = this.datepipe.transform(date, 'yyyy-MM-dd');

    let data = {
      action: this.statusForm.value.action,
      vslNumber: this.statusForm.value.vslNumber,
      reason:this.statusForm.value.resion,
      effectiveDate:effectiveDate,
    };
    
    this._vesselService.changeVesselsStatus(data)
      .subscribe({
        next: (res) => {
         if(res.data.activeInactiveVessel.success){
          this._storageService.putDataInStorage("listReloadAction", "yes");
          this.closePopup();
          this.toasterService.openToast('Success', res.data.activeInactiveVessel.message);
         }
        
        }
      });
  }
}
  
  
